/**
 * Kalkulator kalorii DNZ - kreator 6 krokow + ekran wyniku z bramka e-mail.
 *
 * Ten plik NIE zawiera wzorow. Logika obliczen mieszka w
 * blocks/calories-calculator-calc.js (window.dnzKalk.oblicz), ktory musi byc
 * wczytany PRZED tym plikiem (enqueue w class-calories-calculator.php).
 *
 * Zachowane z poprzedniej wersji:
 * - id/name pol i selektory .summary-*, .validation-message, .tooltip
 * - live-filtrowanie znakow w polach liczbowych
 * - wypelnianie ukrytych pol calckcal_* w formularzu CF7
 * - komunikaty CF7 (.message-success / .message-error) w .summary-footer-rcol
 *
 * Nowe:
 * - kroki, pasek postepu ("Krok n z 6"), auto-przejscie na radiach, walidacja per krok
 * - profil odpowiedzi (kolumna boczna / linia na mobile) z powrotem do kroku
 * - dzialajaca walidacja zakresow (stara byla martwa, BRIEF 3.2)
 * - walidacja liczby treningow (BRIEF 3.1)
 * - bramka: białko widoczne od razu, tłuszcz/węglowodany/posiłki to przed zapisem
 *   WYŁĄCZNIE atrapa (mask()) - realna liczba siedzi w zamknięciu (pendingFats/
 *   pendingCarbs/pendingMeals) i trafia do DOM dopiero w unlockMacros(), więc
 *   "Zbadaj element" przed zapisem jej nie pokaże; odslaniane po wpcf7mailsent
 *   LUB wpcf7mailfailed (kontakt juz zapisany) - bez przycisku pozornego nad
 *   formularzem
 * - posiłki: rozbicie kcal na posiłki (window.dnzKalk.splitMeals)
 * - imię: osobny krok PO odsłonięciu wyniku, AJAX prosto do User.com
 *   (Calories_Calculator::ajax_update_name), niezależny od formularza CF7
 * - dataLayer: kalkulator_start / _krok / _wynik / _email_submit / _makro_odslonione
 */
$(document).ready(function () {

    const $root = $('.dnz-kalk');
    if (!$root.length) return;

    if (!window.dnzKalk || typeof window.dnzKalk.oblicz !== 'function') {
        if (window.console) console.error('dnzKalk: brak calories-calculator-calc.js - kreator nie wystartuje.');
        return;
    }

    const REDUCED_MOTION = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    const FADE = REDUCED_MOTION ? 0 : 300;
    const AUTO_ADVANCE_DELAY = 250;
    const NEWSLETTER_FORM_ID = 'calories-calculator-newsletter-form';

    const $form = $('#calories-calculator-form');
    const $steps = $form.find('.dnz-kalk-step');
    const totalSteps = $steps.length;
    const $progress = $form.find('.dnz-kalk-progress');
    const $summary = $('#summary');
    const $profileLine = $form.find('.dnz-kalk-profile-line');

    let currentStep = 1;
    let started = false;
    let unlocked = false;
    let keyboardChange = false;
    let lastCpm = 0;
    let submittedEmail = '';
    let nameSaved = false;

    // Wartosci pod bramka NIE siedza w DOM przed zapisem (BRIEF sekcja 6: "jeżeli
    // ma to być szczelne, przed zapisem renderuj atrapę [...] i podmieniaj liczbę
    // dopiero po submicie") - realne liczby czekaja tu, w zamknieciu skryptu,
    // niedostepne z poziomu "Zbadaj element".
    let pendingFats = null;
    let pendingCarbs = null;
    let pendingMeals = [];

    // Atrapa o tej samej dlugosci co realna liczba - sama dlugosc niczego nie zdradza.
    function mask(value) {
        return '•'.repeat(String(value).length);
    }

    $root.addClass('dnz-kalk-js');

    // ------------------------------------------------------------------
    // pomiar (BRIEF sekcja 7) - bez masy, wzrostu, wieku i e-maila
    // ------------------------------------------------------------------
    function pushDataLayer(event, params) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push($.extend({ event: event }, params || {}));
    }

    function kcalBucket(cpm) {
        const low = Math.floor(cpm / 300) * 300;
        return low + '-' + (low + 299);
    }

    // ------------------------------------------------------------------
    // tooltipy - zachowanie z poprzedniej wersji + klawiatura
    // ------------------------------------------------------------------
    $('body').on('click', function (e) {
        if ($(e.target).parents().hasClass('tooltip')) {
            e.stopPropagation();
            return;
        }
        $('.tooltip-open').remove();
    });

    $('.tooltip').on('click', function (e) {
        e.preventDefault();
        const already_open = Boolean($(this).find('.tooltip-open').length);
        $('.tooltip-open').remove();
        if (already_open) return;
        const tooltip_text = $(this).prop('title');
        const $tooltip = $(`<div class="tooltip-open" role="tooltip">${tooltip_text}</div>`);

        $(this).append($tooltip);
    });

    $('.tooltip').on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            $(this).trigger('click');
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') $('.tooltip-open').remove();
    });

    // ------------------------------------------------------------------
    // profil odpowiedzi
    // ------------------------------------------------------------------
    function radioLabel(name) {
        const $checked = $form.find('input[name="' + name + '"]:checked');
        if (!$checked.length) return '';
        const $label = $form.find('label[for="' + $checked.attr('id') + '"]').clone();
        $label.find('svg, .tooltip, .dnz-kalk-pill-desc').remove();
        return $label.text().replace(/\s+/g, ' ').trim();
    }

    // Krok 2 dopisuje sie do profilu po kawalku: kazde wypelnione pole dokłada swoja
    // czesc, wyczyszczenie pola ja zabiera. Handler `input` wola renderProfile(),
    // wiec kolumna nadaza za pisaniem.
    function bodyLine() {
        const parts = [];
        [['weight', 'kg'], ['height', 'cm'], ['age', 'lat']].forEach(function (field) {
            const value = String($form.find('input[name="' + field[0] + '"]').val() || '').trim();
            if (value) parts.push(value + ' ' + field[1]);
        });
        return parts.join(' · ');
    }

    function profileValues() {
        const trainings = radioLabel('trainings');
        return {
            plec: radioLabel('sex'),
            dane: bodyLine(),
            aktywnosc: radioLabel('activity'),
            treningi: trainings ? trainings + ' / tydz.' : '',
            cel: radioLabel('goal'),
            plan: radioLabel('plan'),
        };
    }

    function renderProfile() {
        const values = profileValues();
        const chips = [];

        $root.find('[data-profile]').each(function () {
            const key = $(this).data('profile');
            const value = values[key];
            const $item = $(this).closest('.dnz-kalk-profile-item');
            $(this).text(value || 'uzupełnij');
            $item.toggleClass('is-filled', !!value);
            if (value) {
                const step = $item.find('[data-goto]').data('goto');
                chips.push('<button type="button" class="dnz-kalk-chip" data-goto="' + step + '">' + $('<i>').text(value).html() + '</button>');
            }
        });

        $profileLine.html(chips.join('')).prop('hidden', chips.length === 0);
    }

    // ------------------------------------------------------------------
    // kroki
    // ------------------------------------------------------------------
    function stepEl(n) {
        return $steps.filter('[data-step="' + n + '"]');
    }

    function setProgress(n, pct) {
        $progress.attr('aria-valuenow', pct);
        $progress.find('.dnz-kalk-progress-fill').css('width', pct + '%');
        $progress.find('.dnz-kalk-progress-label').text('Krok ' + n + ' z ' + totalSteps);
    }

    function focusFirst($step) {
        const $checked = $step.find('input[type="radio"]:checked');
        const $target = $checked.length ? $checked.first() : $step.find('input:not([type="hidden"]), button').first();
        if (!$target.length) return;
        try {
            $target[0].focus({ preventScroll: true });
        } catch (err) {
            $target[0].focus();
        }
    }

    /**
     * Wysokosc przyklejonego headera motywu. Kolumna profilu tez jest sticky,
     * wiec bez tego offsetu chowa sie pod navbarem; ta sama liczba przesuwa
     * przewijanie do kroku, zeby gora kreatora nie wpadala pod header.
     */
    function stickyTop() {
        const header = document.querySelector('.site-header');
        if (!header) return 0;
        const position = window.getComputedStyle(header).position;
        if (position !== 'sticky' && position !== 'fixed') return 0;
        return Math.round(header.getBoundingClientRect().height) || 0;
    }

    function syncStickyTop() {
        $root[0].style.setProperty('--dnz-kalk-sticky-top', stickyTop() + 'px');
    }

    function scrollToTop($el, offset) {
        const top = $el.offset().top - offset - stickyTop();
        if (REDUCED_MOTION) {
            window.scrollTo(0, top);
        } else {
            $([document.documentElement, document.body]).animate({ scrollTop: top }, 500);
        }
    }

    function showStep(n, options) {
        const opts = options || {};
        const $step = stepEl(n);
        if (!$step.length) return;

        $form.find('.validation-message').hide();
        $steps.removeClass('is-active');
        $step.addClass('is-active');
        currentStep = n;
        setProgress(n, parseInt($step.data('progress'), 10));
        $root.toggleClass('is-step-1', n === 1); // krok 1: blok "Jak liczymy" zamiast profilu
        $root.find('.dnz-kalk-profile-item').removeClass('is-current')
            .filter(function () { return $(this).find('[data-goto]').data('goto') === n; }).addClass('is-current');
        renderProfile();

        if (opts.focus !== false) {
            focusFirst($step);
            if (window.pageYOffset > $root.offset().top - 16) {
                scrollToTop($root, 16);
            }
        }

        pushDataLayer('kalkulator_krok', { krok: n, nazwa_kroku: $step.data('step-name') });
    }

    // powrot do kroku z profilu - takze z ekranu wyniku
    function goToStep(n) {
        if ($summary.css('display') !== 'none') {
            $summary.hide();
            $form.show();
        }
        showStep(n);
    }

    // ------------------------------------------------------------------
    // walidacja
    // ------------------------------------------------------------------
    function showMessage(fieldsetId) {
        $('#' + fieldsetId + ' .validation-message').stop(true, true).fadeIn(FADE);
    }

    function matchesPattern($input) {
        const pattern = new RegExp($input.data('pattern'));
        return pattern.test($input.val());
    }

    function validateRadio(name, fieldsetId, silent) {
        const ok = $form.find('input[name="' + name + '"]:checked').length > 0;
        if (!ok && !silent) showMessage(fieldsetId);
        return ok;
    }

    function validateNumbers(silent) {
        let ok = true;
        ['weight', 'height', 'age'].forEach(function (name) {
            const $input = $form.find('input[name="' + name + '"]');
            if (!matchesPattern($input)) {
                ok = false;
                if (!silent) showMessage(name);
            }
        });
        return ok;
    }

    function validateStep(n, silent) {
        switch (n) {
            case 1: return validateRadio('sex', 'sex', silent);
            case 2: return validateNumbers(silent);
            case 3: return validateRadio('activity', 'activity', silent);
            case 4: return validateRadio('trainings', 'trainings', silent);
            case 5: return validateRadio('goal', 'goal', silent);
            case 6: return validateRadio('plan', 'plan', silent);
        }
        return true;
    }

    function goNext() {
        if (currentStep >= totalSteps) {
            $form.trigger('submit');
            return;
        }
        if (validateStep(currentStep)) showStep(currentStep + 1);
    }

    function refreshStep2() {
        stepEl(2).find('.dnz-kalk-btn-next').prop('disabled', !validateNumbers(true));

        const $age = $form.find('input[name="age"]');
        const age = parseInt($age.val(), 10);
        const showHint = matchesPattern($age) && age >= 16 && age <= 17;
        $('#age-hint').prop('hidden', !showHint);
    }

    function refreshStep6() {
        stepEl(6).find('.dnz-kalk-btn-submit').prop('disabled', !validateRadio('plan', 'plan', true));
    }

    // ------------------------------------------------------------------
    // posiłki - rozbicie kcal na wiersze (window.dnzKalk.splitMeals)
    // ------------------------------------------------------------------
    function renderMeals(cpm) {
        if (typeof window.dnzKalk.splitMeals !== 'function') return;

        const meals = window.dnzKalk.splitMeals(cpm);
        pendingMeals = meals;
        const $meals = $summary.find('[data-role="meals"]');

        // Przed zapisem w DOM idzie wyłącznie atrapa (patrz komentarz przy
        // deklaracji pendingMeals) - po odblokowaniu (np. powrót do kroku i
        // ponowny submit) render od razu pokazuje realne liczby.
        const valueClass = unlocked ? '' : ' class="dnz-kalk-locked-value"';

        $meals.find('[data-role="meals-kcal"]').text(cpm);
        $meals.find('[data-role="meals-count"]').text(meals.length);
        $meals.find('[data-role="meals-rows"]').html(meals.map(function (m) {
            const value = unlocked ? m.kcal : mask(m.kcal);
            return '<div class="dnz-kalk-meals-row"><span>' + $('<i>').text(m.name).html() + '</span>' +
                '<span' + valueClass + '>' + value + ' kcal</span></div>';
        }).join(''));

        $summary.find('[data-role="promo-kcal"]').text(cpm);
    }

    // ------------------------------------------------------------------
    // zdarzenia formularza
    // ------------------------------------------------------------------
    $('input[name="weight"], input[name="height"], input[name="age"]').on('input', function () {
        $(this).val($(this).val().replace(/[^0-9.,]/g, ''));
        $(this).closest('fieldset').find('.validation-message').hide();
        if (!started) {
            started = true;
            pushDataLayer('kalkulator_start');
        }
        refreshStep2();
        renderProfile();
    });

    $form.on('keydown', 'input[name="weight"], input[name="height"], input[name="age"]', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            goNext();
        }
    });

    $form.on('keydown', 'input[type="radio"]', function (e) {
        // strzalki zmieniaja zaznaczenie - nie moga same przerzucac na kolejny krok
        keyboardChange = true;
        setTimeout(function () { keyboardChange = false; }, 400);

        if (e.key === 'Enter') {
            e.preventDefault();
            goNext();
        }
    });

    /*
     * 'change' nie odpala sie, gdy uzytkownik wroci na wczesniejszy krok i kliknie
     * te sama odpowiedz, ktora juz byla zaznaczona - kreator stal wtedy w miejscu.
     * Dlatego ten sam handler wisi tez na 'click'. Przy wyborze nowej opcji odpalaja
     * sie oba zdarzenia, ale drugie przejscie odcina warunek currentStep === n nizej.
     * Strzalki klawiatury nadal nie przerzucaja kroku - pilnuje tego keyboardChange.
     */
    $form.on('change click', 'input[type="radio"]', function () {
        const $input = $(this);
        const $step = $input.closest('.dnz-kalk-step');
        const n = parseInt($step.data('step'), 10);

        $step.find('.validation-message').hide();
        renderProfile();

        if (!started) {
            started = true;
            pushDataLayer('kalkulator_start');
        }

        if (n === totalSteps) {
            refreshStep6();
            return;
        }

        if (n !== currentStep || keyboardChange) return;

        setTimeout(function () {
            if (currentStep === n && $input.is(':checked')) showStep(n + 1);
        }, AUTO_ADVANCE_DELAY);
    });

    $form.on('click', '.dnz-kalk-btn-next', function () {
        goNext();
    });

    $form.on('click', '.dnz-kalk-btn-back', function () {
        if (currentStep > 1) showStep(currentStep - 1);
    });

    $root.on('click', '[data-goto]', function () {
        goToStep(parseInt($(this).data('goto'), 10));
    });

    $form.on('submit', function (e) {
        e.preventDefault();

        // zabezpieczenie: pelna walidacja, gdyby ktos ominal kroki
        for (let n = 1; n <= totalSteps; n++) {
            if (!validateStep(n, true)) {
                showStep(n);
                validateStep(n);
                return;
            }
        }

        const sex = $(this).find('input[name="sex"]:checked').val();
        const weight = $(this).find('input[name="weight"]').val().replace(',', '.');
        const height = $(this).find('input[name="height"]').val().replace(',', '.');
        const age = $(this).find('input[name="age"]').val();
        const activity = $(this).find('input[name="activity"]:checked').val();
        const trainings = $(this).find('input[name="trainings"]:checked').val();
        const goal = $(this).find('input[name="goal"]:checked').val();
        const plan = $(this).find('input[name="plan"]:checked').val();

        const wynik = window.dnzKalk.oblicz(sex, weight, height, age, activity, trainings, goal);

        $('.summary-calories span').html(wynik.cpm);
        $('.summary-proteins span').html(`${wynik.proteins}`);

        // Tłuszcz i węglowodany pod bramką: przed zapisem w DOM idzie tylko
        // atrapa (patrz komentarz przy pendingFats/pendingCarbs); po odblokowaniu
        // (np. powrót do kroku i ponowny submit) od razu realna liczba.
        pendingFats = wynik.fats;
        pendingCarbs = wynik.carbs;
        $('.summary-fats span').html(unlocked ? `${wynik.fats}` : mask(wynik.fats));
        $('.summary-carbs span').html(unlocked ? `${wynik.carbs}` : mask(wynik.carbs));

        lastCpm = wynik.cpm;
        renderMeals(wynik.cpm);

        const goal_text = $('#calories-calculator-form').find('input[name="goal"]:checked').attr('id');

        if (wynik.low_cal_warning) {
            $('.low-cal-warning').show();
        } else {
            $('.low-cal-warning').hide();
        }

        $('input[name="calckcal_user_target"]').val(goal_text);
        $('input[name="calckcal_user_sex"]').val(sex);
        $('input[name="calckcal_user_age"]').val(wynik.seg_age);
        $('input[name="calckcal_user_trainings"]').val(wynik.seg_trainings);
        $('#' + NEWSLETTER_FORM_ID + ' input[name="calckcal_user_plan"]').val(plan);

        if (!unlocked) $summary.addClass('dnz-kalk-locked');

        renderProfile();
        $root.removeClass('is-step-1').find('.dnz-kalk-profile-item').removeClass('is-current');
        $form.hide();
        $('.summary').fadeIn(FADE ? 500 : 0);
        scrollToTop($('#summary'), 100);

        pushDataLayer('kalkulator_wynik', { przedzial_kcal: kcalBucket(wynik.cpm), cel: goal_text });
    });

    // ------------------------------------------------------------------
    // bramka e-mail (CF7)
    // ------------------------------------------------------------------
    function $newsletterForm() {
        return $('#' + NEWSLETTER_FORM_ID);
    }

    function $gate() {
        return $root.find('.summary-footer-rcol');
    }

    function isOurEvent(e) {
        // CF7 >= 5.2 wysyla zdarzenia na div.wpcf7 (bubbling); starsze - na document
        return e.target === document || $(e.target).closest('.dnz-kalk').length > 0;
    }

    function releaseNewsletterForm() {
        $newsletterForm().removeClass('dnz-kalk-submitting').find('.wpcf7-submit').prop('disabled', false);
    }

    // Odsłonięcie w miejscu: makro, posiłki i panel "po zapisie" wchodzą razem,
    // bez przeładowania strony i bez osobnego thank-you page (BRIEF sekcja 3).
    function unlockMacros() {
        if (unlocked) return;
        unlocked = true;

        // Realne liczby wchodzą do DOM dopiero teraz - do tego momentu w źródle
        // strony (i w "Zbadaj element") siedziała wyłącznie atrapa (patrz mask()).
        if (pendingFats !== null) $('.summary-fats span').text(pendingFats);
        if (pendingCarbs !== null) $('.summary-carbs span').text(pendingCarbs);
        $summary.find('[data-role="meals-rows"] .dnz-kalk-meals-row').each(function (i) {
            const meal = pendingMeals[i];
            if (!meal) return;
            $(this).find('span').last().text(meal.kcal + ' kcal');
        });

        $summary.removeClass('dnz-kalk-locked');
        $summary.find('[data-role="progress-label"]').hide();
        $summary.find('.dnz-kalk-locked-value').removeClass('dnz-kalk-locked-value');
        $summary.find('[data-role="meals"]').removeClass('dnz-kalk-meals--teased');
        $gate().hide();

        const $done = $summary.find('[data-role="done"]');
        $done.find('[data-role="sent-to"]').text(submittedEmail);
        $done.prop('hidden', false);

        pushDataLayer('kalkulator_makro_odslonione');
        scrollToTop($('.summary-macro'), 100);
    }

    // honeypot po stronie klienta (serwerowy: tag [honeypot] w CF7, patrz WDROZENIE.md)
    $newsletterForm().append('<input type="text" name="dnz_kalk_hp" class="dnz-kalk-hp" tabindex="-1" autocomplete="off" aria-hidden="true" />');

    // faza capture: odpalamy sie PRZED wlasnym listenerem CF7 na <form>
    document.addEventListener('submit', function (e) {
        const formEl = e.target;
        if (!formEl || formEl.id !== NEWSLETTER_FORM_ID) return;

        const $f = $(formEl);
        const honeypot = $f.find('.dnz-kalk-hp').val();
        const email = String($f.find('input[type="email"]').first().val() || '').trim();
        const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
        const $consent = $f.find('input[type="checkbox"]').first();
        const consentOk = !$consent.length || $consent.is(':checked');
        const busy = $f.hasClass('dnz-kalk-submitting');

        if (honeypot || !emailOk || !consentOk || busy) {
            e.preventDefault();
            e.stopPropagation();
            if (!honeypot && !busy) {
                $gate().find('.message-error').stop(true, true).fadeIn(FADE);
            }
            return;
        }

        $gate().find('.message-error').hide();
        $f.addClass('dnz-kalk-submitting').find('.wpcf7-submit').prop('disabled', true);
        submittedEmail = email;
        pushDataLayer('kalkulator_email_submit');
    }, true);

    $(document).on('wpcf7invalid wpcf7spam', function (e) {
        if (!isOurEvent(e)) return;
        releaseNewsletterForm();
        $gate().find('.message-error').stop(true, true).fadeIn(FADE);
    });

    // kontakt zapisany -> odslaniamy, nawet gdy mail nie wyszedl (BRIEF sekcja 5)
    $(document).on('wpcf7mailsent wpcf7mailfailed', function (e) {
        if (!isOurEvent(e)) return;
        releaseNewsletterForm();
        unlockMacros();
    });

    // ------------------------------------------------------------------
    // imię - dopiero po odsłonięciu wyniku, osobny zapis prosto do User.com
    // (kontakt już istnieje po kroku wyżej - tu tylko dopisujemy first_name)
    // ------------------------------------------------------------------
    $root.on('click', '[data-role="name-save"]', function () {
        const $btn = $(this);
        const $wrap = $btn.closest('.dnz-kalk-name');
        const $input = $wrap.find('[data-role="name-input"]');
        const $message = $wrap.find('[data-role="name-message"]');
        const name = String($input.val() || '').trim();

        if (!name || nameSaved || !submittedEmail) return;
        if (typeof dnzKalkData === 'undefined' || !dnzKalkData.ajax_url) return;

        $btn.prop('disabled', true);

        $.post(dnzKalkData.ajax_url, {
            action: 'calories_calculator_update_name',
            security: dnzKalkData.nonce,
            email: submittedEmail,
            name: name
        }).always(function () {
            // Pominięcie jest bez konsekwencji (BRIEF sekcja 3.5) - nawet gdyby
            // zapis się nie udał, nie blokujemy użytkownika drugą próbą.
            nameSaved = true;
            $input.prop('disabled', true);
            $btn.prop('disabled', true);
            $message.prop('hidden', false);
        });
    });

    // ------------------------------------------------------------------
    // start
    // ------------------------------------------------------------------
    syncStickyTop();
    $(window).on('resize', syncStickyTop);

    refreshStep2();
    refreshStep6();
    showStep(1, { focus: false });
});
